import { use } from 'react';

import { type DocyrusAuthContextValue } from '../types';

import { DocyrusAuthContext } from '../components/auth-context';

/**
 * Hook to access Docyrus auth state.
 * Must be used within a <DocyrusAuthProvider>.
 *
 * Returns: { status, mode, tokens, signIn, signInWithTokens, signOut, client, error }
 */
export function useDocyrusAuth(): DocyrusAuthContextValue {
  const context = use(DocyrusAuthContext);

  if (!context) {
    throw new Error(
      'useDocyrusAuth must be used within a <DocyrusAuthProvider>. '
      + 'Wrap your app with <DocyrusAuthProvider> to provide auth context.'
    );
  }

  return context;
}
